import React from 'react';
import { Truck, Wrench, Forklift, Container, Car, Settings } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/fleet-maintenance`;

export const STATUS_META = {
  overdue: { label: 'Overdue', pill: 'bg-red-100 text-red-800 border-red-300', dot: 'bg-red-500' },
  due_soon: { label: 'Due soon', pill: 'bg-amber-100 text-amber-900 border-amber-300', dot: 'bg-amber-500' },
  ok: { label: 'OK', pill: 'bg-emerald-100 text-emerald-800 border-emerald-300', dot: 'bg-emerald-500' },
  as_needed: { label: 'As needed', pill: 'bg-sky-50 text-sky-800 border-sky-200', dot: 'bg-sky-400' },
  no_baseline: { label: 'Needs baseline', pill: 'bg-slate-100 text-slate-600 border-slate-300 border-dashed', dot: 'bg-slate-400' },
  no_plan: { label: 'No plan', pill: 'bg-slate-100 text-slate-500 border-slate-200 border-dashed', dot: 'bg-slate-300' },
  retired: { label: 'Retired', pill: 'bg-slate-200 text-slate-600 border-slate-300', dot: 'bg-slate-500' },
};

export const TYPE_LABEL = { truck: 'Truck', trailer: 'Trailer', forklift: 'Forklift', welder: 'Welder', personal_vehicle: 'Personal vehicle', other: 'Equipment' };

export const TypeIcon = ({ type, className = 'w-5 h-5' }) => {
  const t = (type || '').toLowerCase();
  if (t === 'truck') return <Truck className={className} />;
  if (t === 'trailer') return <Container className={className} />;
  if (t === 'forklift') return <Forklift className={className} />;
  if (t === 'welder') return <Wrench className={className} />;
  if (t === 'personal_vehicle') return <Car className={className} />;
  return <Settings className={className} />;
};

export const fmtMeter = (meter) => {
  if (!meter?.kind) return null;
  if (meter.kind === 'km') return meter.km != null ? `${Math.round(meter.km).toLocaleString()} km` : 'no odometer reading';
  return meter.hours != null ? `${meter.hours.toLocaleString()} hrs` : 'no hour-meter reading';
};

export const intervalText = (it) => [
  it.interval_km ? `${Number(it.interval_km).toLocaleString()} km` : null,
  it.interval_hours ? `${Number(it.interval_hours).toLocaleString()} hrs` : null,
  it.interval_months ? (Number(it.interval_months) % 12 === 0 ? `${Number(it.interval_months) / 12} yr` : `${Number(it.interval_months)} mo`) : null,
  it.interval_days ? (Number(it.interval_days) % 7 === 0 ? `${Number(it.interval_days) / 7} wk` : `${Number(it.interval_days)} days`) : null,
].filter(Boolean).join(' / ') || 'as needed';

export const fmtDate = (s) => (s ? new Date(s.slice(0, 10) + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');

export const StatusPill = ({ status, children, testid }) => {
  const m = STATUS_META[status] || STATUS_META.no_plan;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap ${m.pill}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />{children || m.label}
    </span>
  );
};
